const CongratsModal=()=>{
    return (
        <div class="modal fade" id="congratsModal" tabindex="-1">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title bigText">CONGRATULATIONS!</h5>
              <p class="bigSubText">You have won 500 Mudras</p>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body pt-0">
              <div class="px-2 text-center shareModal">
                <p>Invite 5 of your friends to register with us</p>
                <span>Earn 250 Mudras <b><img src="assets/img/icons/coin.svg" alt="#" /></b></span>
                <div class="socialShare">
                  <small>Invite via</small>
                  <ul>
                    <li><a><img src="assets/img/icons/facebook-48.png" alt="#" /></a></li>
                    <li><a><img src="assets/img/icons/whatsapp-48.png" alt="#" /></a></li>
                    <li><a><img src="assets/img/icons/instagram-48.png" alt="#" /></a></li>
                    <li><a><img src="assets/img/icons/twitter-48.png" alt="#" /></a></li>
                    <li><a><img src="assets/img/icons/linkedin-48.png" alt="#" /></a></li>
                  </ul>
                </div>
                <div class="divideLine"><b>or</b></div>
                <div class="codeBelow">
                  <small>Use the code below</small>
                  <div class="codeWrap">
                    <p>WELCOME12</p>
                    <p><b></b>Copy Code</p>
                  </div>
                </div>
                <small>*You can check your reward in “My Income” section.</small>
    
              </div>
            </div>
    
          </div>
        </div>
      </div>
    )
}
export default CongratsModal